if(!customElements.get('option-selector')) {
    class OptionSelector extends HTMLElement {
        constructor(){
            super();
            this.optionContainers = this.querySelectorAll('.single-option');
            this.onchange = this.updateOption;
        }

        updateOption = () => {
            console.log(this);
            this.optionContainers.forEach(option => {
                if(option.querySelector('input:checked')){
                    document.querySelector('.yotpo-subscription-label-price').textContent = option.querySelector('.right-side span').dataset.price;
                    document.querySelectorAll('.yotpo-subscription-label-price')[1].textContent = option.querySelector('.right-side span').dataset.subscribe;
                    option.querySelectorAll('select').forEach(select => {
                        select.disabled = false;
                    });
                    option.querySelectorAll('.selling_plan').forEach(input => {
                        input.disabled = false;
                    });

                    document.querySelector('.yotpo-widget-subscriptions-add-to-cart').querySelectorAll('input').forEach(s_input => {
                        if(s_input.checked == true) {
                            option.querySelectorAll('.selling_plan').forEach(input => {
                                input.value = s_input.value;
                            });     
                        }else {
                            input.value = '';
                        }
                    })
                }else {
                    option.querySelectorAll('select').forEach(select => {
                        select.disabled = true;
                    });
                    option.querySelectorAll('.selling_plan').forEach(input => {
                        input.disabled = true;
                        input.value = '';
                    });
                }
            })
        }
    }

    customElements.define('option-selector', OptionSelector);
}

const suscriptionApp = setInterval(() => {
    if(document.querySelector('.yotpo-widget-subscriptions-add-to-cart')){
        clearInterval(suscriptionApp);
        setTimeout(() => {
            console.log(document.querySelector('.yotpo-widget-subscriptions-add-to-cart'));
            document.querySelector('.yotpo-widget-subscriptions-add-to-cart').querySelectorAll('input').forEach(input => {
                input.addEventListener('change', function(){
                    const inputValue = this.value;
                    document.querySelectorAll('.single-option').forEach(option => {
                        console.log(option);
                        if(option.querySelector('input:checked')){
                            option.querySelectorAll('.selling_plan').forEach(input => {
                                input.value = inputValue;
                            });
                            setTimeout(() => {
                                document.querySelector('.yotpo-subscription-label-price').textContent = option.querySelector('.right-side span').dataset.price;
                                document.querySelectorAll('.yotpo-subscription-label-price')[1].textContent = option.querySelector('.right-side span').dataset.subscribe;
                            }, 10);
                        }else {
                            option.querySelectorAll('.selling_plan').forEach(input => {
                                console.log(input);
                                input.value = '';
                            });
                        }
                    });
                });
            })

            document.querySelector('.yotpo-widget-subscriptions-add-to-cart').querySelectorAll('input').forEach(s_input => {
                if(s_input.checked == true) {
                    document.querySelectorAll('.single-option').forEach(option => {
                        if(option.querySelector('input:checked')){
                            option.querySelectorAll('.selling_plan').forEach(input => {
                                input.value = s_input.value;
                            });
                        }else {
                            option.querySelectorAll('.selling_plan').forEach(input => {
                                input.value = '';
                            }); 
                        }
                    });
                }
            })
        }, 1500);
    }   
});


const swiper = new Swiper('.swiper-main', {
    loop: true,

    // If we need pagination
    pagination: {
        enabled: false,
        el: '.swiper-pagination-main',
    },

    // Navigation arrows
    navigation: {
        enabled: false,
        nextEl: '.swiper-button-next-main',
        prevEl: '.swiper-button-prev-main',
    },

    // And if we need scrollbar
    scrollbar: {
        enabled: false,
        el: '.swiper-scrollbar-main',
    },
    on: {
        slideChange: (event) => {
            const slideIndex = event.activeIndex;
            const activeIndex = event.slides[slideIndex].dataset.mediaId;
            document.querySelectorAll('.thumb-media-gallery img').forEach((image, index) => {
                if(image.parentElement.dataset.mediaId == activeIndex){
                    image.classList.add('active');
                }else {
                    image.classList.remove('active');
                }
            });
        }
    }
});

const swiperThumb = new Swiper('.swiper-thumb', {
    loop: true,
    slidesPerView: 4,
    spaceBetween: 10,
    // If we need pagination
    pagination: {
        enabled: false,
        el: '.swiper-pagination-thumb',
    },

    // Navigation arrows
    navigation: {
        enabled: false,
        nextEl: '.swiper-button-next-thumb',
        prevEl: '.swiper-button-prev-thumb',
    },

    // And if we need scrollbar
    scrollbar: {
        enabled: false,
        el: '.swiper-scrollbar-thumb',
    },
});


function changeSlide(slide) {
    // document.querySelectorAll('.thumb-media-gallery img').forEach(image => {
    //     image.classList.remove('active');
    // });
    // slide.querySelector('img').classList.add('active');
    swiper.slideTo(slide.dataset.swiperSlideIndex);
}

async function addProduct(event, form){
    event.preventDefault();
    form.querySelector('button[type=submit]').classList.add('load');
    var data = theme.utils.serialize(form);
    fetch(theme.routes.cartAdd, {
        method: 'POST',
        body: data,
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
        }
    })
    .then(response => response.json())
    .then(function(data) {
        if (data.status === 422) {
            console.log('error');
        } else {
            var product = data;
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: {
                  product: product,
                  addToCartBtn: false
                }
            }));
            if(document.querySelector('[data-add-to-cart].load')){
                document.querySelector('[data-add-to-cart].load').classList.remove('load')
            }
        }
    })
}